const single_sign_on = {
    forbidden_domains: '不允許使用公共電郵域名。',
    duplicated_domains: '存在重複的域名。',
    invalid_domain_format: '無效的域名格式。',
    duplicate_connector_name: '連接器名稱已存在。請選擇不同的名稱。',
};
export default Object.freeze(single_sign_on);
